// Mapeamento centralizado de perfis para exibição (labels em pt-BR)
// Inclui perfis canônicos, legados e o novo 'cliente' (Portal do Cliente interno)

export const PERFIL_LABELS: Record<string, string> = {
  // Canônicos
  dono: 'Proprietário',
  gerente: 'Gerente',
  engenheiro: 'Engenheiro',
  administrativo: 'Administrativo',
  tst: 'TST',
  encarregado: 'Encarregado',
  empreiteiro: 'Empreiteiro',
  assistente: 'Assistente',
  visualizador: 'Visualizador',
  cliente: 'Cliente',

  // Legados / aliases
  diretoria: 'Diretoria',
  coordenador: 'Coordenador',
  mestre: 'Mestre de Obras',
  tecnico_sst: 'Técnico de SST',
  almoxarife: 'Almoxarife',
  super_admin: 'Administrador',
  superadmin: 'Administrador',
  admin: 'Administrador',
  gestor: 'Gestor',
  tecnico: 'Técnico',
  operario: 'Operário',
}

export const getPerfilLabel = (perfil?: string | null): string => {
  if (!perfil) return '—'
  const key = String(perfil).trim().toLowerCase()
  return PERFIL_LABELS[key] || perfil
}

// Itens de menu permitidos para o perfil 'cliente' (visualização restrita)
export const CLIENTE_MENU_KEYS = new Set<string>([
  'obra-dash',
  'fotos',
  'cronograma',
  'diario',
  'documentos',
])

export const isClientePerfil = (perfil?: string | null): boolean =>
  String(perfil || '').trim().toLowerCase() === 'cliente'
